import { createContext } from 'react';

export interface CartDishModalContextProps {
  showDishModal?: () => void;
}

export const CartDishModalContext = createContext<CartDishModalContextProps>({});
CartDishModalContext.displayName = 'CartDishModalContext';
